import colors from '@motusi/styles/theme/colors';

export default {
  colorPrimary: {
    color: colors.primary['300'],
  },
};
